export const US_STATES = [
  { value: "AL", label: "Alabama (AL)", name: "Alabama" },
  { value: "AK", label: "Alaska (AK)", name: "Alaska" },
  { value: "AZ", label: "Arizona (AZ)", name: "Arizona" },
  { value: "AR", label: "Arkansas (AR)", name: "Arkansas" },
  { value: "CA", label: "California (CA)", name: "California" },
  { value: "CO", label: "Colorado (CO)", name: "Colorado" },
  { value: "CT", label: "Connecticut (CT)", name: "Connecticut" },
  { value: "DE", label: "Delaware (DE)", name: "Delaware" },
  { value: "DC", label: "District of Columbia (DC)", name: "District of Columbia" },
  { value: "FL", label: "Florida (FL)", name: "Florida" },
  { value: "GA", label: "Georgia (GA)", name: "Georgia" },
  { value: "GU", label: "Guam (GU)", name: "Guam" },
  { value: "HI", label: "Hawaii (HI)", name: "Hawaii" },
  { value: "ID", label: "Idaho (ID)", name: "Idaho" },
  { value: "IL", label: "Illinois (IL)", name: "Illinois" },
  { value: "IN", label: "Indiana (IN)", name: "Indiana" },
  { value: "IA", label: "Iowa (IA)", name: "Iowa" },
  { value: "KS", label: "Kansas (KS)", name: "Kansas" },
  { value: "KY", label: "Kentucky (KY)", name: "Kentucky" },
  { value: "LA", label: "Louisiana (LA)", name: "Louisiana" },
  { value: "ME", label: "Maine (ME)", name: "Maine" },
  { value: "MD", label: "Maryland (MD)", name: "Maryland" },
  { value: "MA", label: "Massachusetts (MA)", name: "Massachusetts" },
  { value: "MI", label: "Michigan (MI)", name: "Michigan" },
  { value: "MN", label: "Minnesota (MN)", name: "Minnesota" },
  { value: "MS", label: "Mississippi (MS)", name: "Mississippi" },
  { value: "MO", label: "Missouri (MO)", name: "Missouri" },
  { value: "MT", label: "Montana (MT)", name: "Montana" },
  { value: "NE", label: "Nebraska (NE)", name: "Nebraska" },
  { value: "NV", label: "Nevada (NV)", name: "Nevada" },
  { value: "NH", label: "New Hampshire (NH)", name: "New Hampshire" },
  { value: "NJ", label: "New Jersey (NJ)", name: "New Jersey" },
  { value: "NM", label: "New Mexico (NM)", name: "New Mexico" },
  { value: "NY", label: "New York (NY)", name: "New York" },
  { value: "NC", label: "North Carolina (NC)", name: "North Carolina" },
  { value: "ND", label: "North Dakota (ND)", name: "North Dakota" },
  { value: "MP", label: "Northern Mariana Islands (MP)", name: "Northern Mariana Islands" },
  { value: "OH", label: "Ohio (OH)", name: "Ohio" },
  { value: "OK", label: "Oklahoma (OK)", name: "Oklahoma" },
  { value: "OR", label: "Oregon (OR)", name: "Oregon" },
  { value: "PA", label: "Pennsylvania (PA)", name: "Pennsylvania" },
  { value: "PR", label: "Puerto Rico (PR)", name: "Puerto Rico" },
  { value: "RI", label: "Rhode Island (RI)", name: "Rhode Island" },
  { value: "SC", label: "South Carolina (SC)", name: "South Carolina" },
  { value: "SD", label: "South Dakota (SD)", name: "South Dakota" },
  { value: "TN", label: "Tennessee (TN)", name: "Tennessee" },
  { value: "TX", label: "Texas (TX)", name: "Texas" },
  { value: "TT", label: "Trust Territories (TT)", name: "Trust Territories" },
  { value: "UT", label: "Utah (UT)", name: "Utah" },
  { value: "VT", label: "Vermont (VT)", name: "Vermont" },
  { value: "VI", label: "Virgin Islands (VI)", name: "Virgin Islands" },
  { value: "VA", label: "Virginia (VA)", name: "Virginia" },
  { value: "WA", label: "Washington (WA)", name: "Washington" },
  { value: "WV", label: "West Virginia (WV)", name: "West Virginia" },
  { value: "WI", label: "Wisconsin (WI)", name: "Wisconsin" },
  { value: "WY", label: "Wyoming (WY)", name: "Wyoming" },
];

export const getUsStateByCode = (code?: string) =>
  US_STATES.find((state) => state.value === String(code || "").toUpperCase());

export const getUsStateByName = (name?: string) =>
  US_STATES.find((state) => state.name.toLowerCase() === String(name || "").toLowerCase());
